exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".changelog{background-color:#232323!important}.changelog .logo{width:247px;margin:0 auto;margin-top:60px;padding:15px;text-align:center}.changelog .content{background-color:#fff;width:70%;margin:0 auto;margin-bottom:0;padding:30px;padding-top:20px;padding-bottom:15px}.changelog .copyright{text-align:center;width:250px;margin:0 auto;padding:10px 10px 0;color:#818181;font-size:11px}.changelogCtrl a{font-family:roboto-reg}.changelogCtrl .pageTitle{font-size:34px;margin:0 0 30px;line-height:34px}.changelog < ul < li{margin-bottom:30px}#loadMore{background-color:#e54d42;box-shadow:0 6px 0 #c34238;color:#fff;width:100%;cursor:pointer;display:block;text-decoration:none;border-bottom:0;padding:12px 0;margin:50px auto;position:relative;font-weight:700;font-size:20px;text-align:center;border-radius:4px;opacity:1}#loadMore:hover{opacity:.9;top:2px;box-shadow:0 4px 0 #c34238}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./src/system/assets/css/views/changelog.css
 ** module id = 366
 ** module chunks = 0
 **/